import { render } from "./SecondaryInfoModal.vue?vue&type=template&id=1f482aa2"
import script from "./SecondaryInfoModal.vue?vue&type=script&lang=js"
export * from "./SecondaryInfoModal.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__